module.exports = __webpack_public_path__ + "img/green_016.ebc3bca9.png";